export const getCartValueFromJob = (job) => {
   job = JSON.parse(JSON.stringify(job))
   let servicePrice = 0
   let turnAroundTime = 0
   if (job.service[0]) {
      servicePrice = Number(job.service[0].price)
   }
   let preferencePrice = 0
   let basePreferencePrice = 0

   job.preferences_obj.forEach(pref => {
      preferencePrice += Number(pref.cost)
   })
   job.base_preferences_obj.forEach(pref => {
      basePreferencePrice += Number(pref.price)
   })
   if (job.summary.items) {
      turnAroundTime = job.summary.items.find(item => item.item_type === 'turn around time')
      turnAroundTime = Number(turnAroundTime.item_price)
   }
   return (servicePrice + preferencePrice + basePreferencePrice) * job.output_file_count + (turnAroundTime)
}
